export default __webpack_public_path__ + "poppins-semibold-webfont.woff2";